import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { TabPane } from 'reactstrap';
import { useAppKeyWords, useHasRights } from 'hooks';
import PermissionDenied from 'shared/permissionDenied';
import { Divider, Layout, SelectReduxFormWrapper, Typography } from '@hub-mono/ui';
import styled from 'styled-components';

const StyledLayout = styled(Layout)`
    padding: 1.5rem 0.6rem 1.5rem;
`;

const ProjectTab = ({ tabId, projects, resourceGroups }) => {
    const { resourceKeyWord, projectPluralKeyWord } = useAppKeyWords();
    const { hasSettingResourceGroups, hasSettingResourcePro } = useHasRights([
        {
            rights: ['settingResourceGroups'],
            rule: 'one',
            name: 'hasSettingResourceGroups',
        },
        {
            rights: ['settingResourcePro'],
            rule: 'one',
            name: 'hasSettingResourcePro',
        },
    ]);
    return (
        <TabPane tabId={tabId}>
            {hasSettingResourcePro && (
                <>
                    <StyledLayout stack gap="--Spacing-150">
                        <Typography variant="label" size="large">
                            Add {projectPluralKeyWord}:
                        </Typography>
                        <Field
                            inline
                            width="col-md-12"
                            name="projects"
                            component={SelectReduxFormWrapper}
                            caseSensitive={false}
                            optionValue="id"
                            filter="contains"
                            optionLabel="name"
                            multiple
                            options={projects}
                            dataCy="res-modal-projects"
                            helperText={`Choose which ${projectPluralKeyWord} belong to this ${resourceKeyWord}`}
                        />
                    </StyledLayout>
                    <Divider />
                </>
            )}
            {hasSettingResourceGroups && (
                <StyledLayout stack gap="--Spacing-150">
                    <Typography variant="label" size="large">
                        Add to Groups:
                    </Typography>
                    <Field
                        inline
                        width="col-md-12"
                        name="resourceGroups"
                        component={SelectReduxFormWrapper}
                        caseSensitive={false}
                        dropUp={true}
                        optionValue="_id"
                        filter="contains"
                        optionLabel="name"
                        multiple
                        options={resourceGroups}
                        dataCy="res-modal-groups"
                        helperText={`Choose which Groups belong to this ${resourceKeyWord}`}
                    />
                </StyledLayout>
            )}
            {!hasSettingResourceGroups && !hasSettingResourcePro && <PermissionDenied />}
        </TabPane>
    );
};

ProjectTab.propTypes = {
    tabId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projects: PropTypes.array,
    resourceGroups: PropTypes.array,
};

ProjectTab.defaultProps = {
    projects: [],
    resourceGroups: [],
};

export default ProjectTab;
